import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bootstrapAuth } from '../../redux/actions/auth';
import { getPromoter } from '../../redux/actions/promoter';

const AuthBootstrapper = ({ children }) => {
  const dispatch = useDispatch();

  const { user, isAuthenticated, initialized } = useSelector(
    (state) => state.auth
  );
  const { me, loading: promoterLoading } = useSelector(
    (state) => state.promoter
  );

  useEffect(() => {
    dispatch(bootstrapAuth());
  }, [dispatch]);

  // T2B-423: the Easypay gate (dimmed "Create event" buttons, the header
  // reminder, the /create-event redirect) needs `easypayAccountId`, which only
  // the promoter profile carries. Until now that was fetched by the Dashboard
  // alone, so everywhere else had no way to know whether the promoter was
  // connected — and a gate that can't see the answer would either flash the
  // wrong state or block a promoter who is perfectly fine.
  //
  // Fetched once per session and left alone: nothing outside the admin panel
  // can change the account id, so there is nothing to poll for. The Dashboard
  // still refetches on its own, which refreshes this same slice.
  //
  // Keyed on `me` — the slice only this promoter's profile can land in — rather
  // than on `promoter`, which event and brand pages fill with whoever they are
  // showing. Watching that one would refetch on every such page, and the
  // refetch would overwrite what the page had just put there.
  const promoterId = user?.role === 'promoter' ? user?.id : null;

  useEffect(() => {
    if (!initialized || !isAuthenticated || !promoterId) return;
    if (me?.id === promoterId || promoterLoading) return;
    dispatch(getPromoter(promoterId));
  }, [
    dispatch,
    initialized,
    isAuthenticated,
    promoterId,
    me?.id,
    promoterLoading,
  ]);

  return children;
};

export default AuthBootstrapper;
